import { render, staticRenderFns } from "./thinktankList.vue?vue&type=template&id=e89151d0&scoped=true"
import script from "./thinktankList.vue?vue&type=script&lang=js"
export * from "./thinktankList.vue?vue&type=script&lang=js"
import style0 from "./thinktankList.vue?vue&type=style&index=0&id=e89151d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89151d0",
  null
  
)

export default component.exports